import React, { useEffect, useState } from "react";
import { Column, Filters } from "react-table";
import ImagerApi from "../../api/ImagerApi";
import PlateApi from "../../api/PlateApi";
import IconImagePlate from "../../Icons/Command/ImageNow";
import IconMovePlate from "../../Icons/Command/MovePlateTo";
import IconPlateInfo from "../../Icons/Command/PlateInfo";
import IconLoadport from "../../Icons/SideMenu/LoadPort";
import IconSearch from "../../Icons/SideMenu/Search";
import IconClearDropLocation from "../../Icons/TopCommandPanel/ClearAllDrop";
import IconUpdateAllPlateInfo from "../../Icons/TopCommandPanel/UpdateAllPlateInfo";
import IconUpdatePlateInfo from "../../Icons/Command/UpdatePlateInfo";
import IconClearFilter from "../../Icons/TopCommandPanel/ClearFilter";
import IconExport from "../../Icons/TopCommandPanel/Export";
import { EDropLocationCacheStatus } from "../../Model/EDropLocationCacheStatus";
import { EModuleType } from "../../Model/EModuleType";
import { EComponentId } from "../../Model/Permission";
import { CanMovePlate, EPlateErrorStatus } from "../../Model/Plate";
import { PlateAddress } from "../../Model/PlateAddress";
import {
  getModuleById,
  getModulesByType,
} from "../../redux/reducers/ModuleReducer";
import {
  getModuleStateById,
  getPlateBarcodesOnImager,
} from "../../redux/reducers/ModuleStateReducer";
import {
  getPlateAddresses,
  getPlateAddressesOnModule,
} from "../../redux/reducers/PlateAddressReducer";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import DateUtil from "../../Utility/DateUtil";
import PlateUtil from "../../Utility/PlateUtil";
import CommandPanel from "../CommandPanel/CommandPanel";
import CommonTable from "../Common/CommonTable";
import LayoutContent from "../LayoutContent";
import { NavSubItemWithPermission } from "../Sidebar/NavSubItem";
import SidebarSubmenu from "../Sidebar/SidebarSubmenu";
import CommandButton from "./../CommandPanel/CommandPanelButton";
import Breadcrumb from "./../Header/Breadcrumb";
import Header from "./../Header/Header";
import HeaderButton from "./../Header/HeaderButton";
import ClearDropLocation from "./CommandPanelViews/ClearDropLocation";
import ImagePlateUsing from "./CommandPanelViews/ImagePlateUsing";
import MovePlate from "./CommandPanelViews/MovePlate";
import PlateInformation from "./CommandPanelViews/PlateInformation";
import { PlateAdressStatusColumnFilter } from "./PlateAdressStatusColumnFilter";
import { IconClearPlateRegsitration } from "../../Icons";
import StorageApi from "../../api/StorageApi";
import ClearPlateConfirmationModal from "./ClearPlateConfirmationModal";
import Modal from "../Common/Modal";
import WarningWaitView from "../../WarningWaitView";

const EXPORT = "EXPORT";
const MOVE = "MOVE";
const CANCEL_MOVE = "CANCEL_MOVE";
const IMAGEPLATE = "IMAGEPLATE";
const INFO = "INFO";
const SEARCH = "SEARCH";
const CLEARDROP = "CLEAR";
const CLEAR_REGISTRATION = "CLEAR_REGISTRATION";
const UPDATE_ALL_PLATE_INFO = "UPDATE_ALL_PLATE_INFO";
const UPDATE_PLATE_INFO = "UPDATE_PLATE_INFO";

export default function Search() {
  const plateAddresses = useTypedSelector((state) => getPlateAddresses(state));

  const [isModalClearPlateOpen, setIsModalClearPlateOpen] = useState(false);
  const [selectedPlateAddresses, setSelectedPlateAddresses] = useState(
    [] as PlateAddress[]
  );
  const [enableUpdatePlateInfo, setEnableUpdatePlateInfo] = useState(true);
  const [showWaitingUpdatePlateInfo, setShowWaitingUpdatePlateInfo] = useState(false);
  const isRowSelected = !!selectedPlateAddresses.length;
  const [commandPanel, setCommandPanel] = useState(SEARCH);
  const moduleById = useTypedSelector((state) => getModuleById(state));
  const modulesByType = useTypedSelector((state) => getModulesByType(state));
  const psrModule = modulesByType[EModuleType.PSR][0];
  const loadPort = modulesByType[EModuleType.LOADPORT][0];
  const imagers = modulesByType[EModuleType.IMAGER];
  const chambers = modulesByType[EModuleType.CHAMBER];

  const moduleStateById = useTypedSelector((state) =>
    getModuleStateById(state)
  );

  const loadPortModules = modulesByType[EModuleType.LOADPORT].map(
    (m) => m.identifier
  );
  const storageModules = modulesByType[EModuleType.CHAMBER].map(
    (m) => m.identifier
  );

  const plateBarcodesOnPsr = useTypedSelector(
    (state) =>
      getPlateAddressesOnModule(state, psrModule.identifier)
        .map((pa) => pa.usedByPlate?.barcode)
        .filter((barcode) => barcode != null) as string[],
    (next, prev) => JSON.stringify(next) === JSON.stringify(prev)
  );
  const plateBarcodesOnImager = useTypedSelector(
    (state) => getPlateBarcodesOnImager(state),
    (next, prev) => JSON.stringify(next) === JSON.stringify(prev)
  );

  const [filteredPlateAddress, setFilteredPlateAddress] = useState(
    [] as PlateAddress[]
  );
  const [clearFilter, setClearFilter] = useState({
    filters: [] as Filters<PlateAddress>,
    action: () => { },
  });
  const [plateDropLocationCacheStatus, setPlateDropLocationCacheStatus] =
    useState(EDropLocationCacheStatus.NoDropLocationCacheExist);

  const [canMovePlateByModuleIdentifier, setCanMovePlateByModuleIdentifier] =
    useState({} as { [moduleIdentifier: string]: boolean });

  useEffect(() => {
    setCanMovePlateByModuleIdentifier({});
    if (selectedPlateAddresses.length == 0) return;
    PlateApi.canMovePlateAddress(selectedPlateAddresses).then((arr) => {
      const result: { [index: string]: boolean } = arr.reduce(
        (map: { [index: string]: boolean }, obj: CanMovePlate) => (
          (map[obj.moduleIdentifier] = obj.canMove), map
        ),
        {}
      );
      setCanMovePlateByModuleIdentifier(result);
    });
  }, [selectedPlateAddresses]);

  const back = () => {
    setCommandPanel(SEARCH);
  };

  const close = () => {
    setSelectedPlateAddresses([]);
    setCommandPanel(SEARCH);
  };

  const onClick = (id: string) => {
    setCommandPanel(id);
  };

  const onCancelMove = () => {
    PlateApi.cancelMovePlates(selectedPlateAddresses);
  };

  const onClearDropLocation = () => {
    if (
      plateDropLocationCacheStatus ===
      EDropLocationCacheStatus.DropLocationCacheExistOnImagerAndLims
    ) {
      setCommandPanel(CLEARDROP);
    } else {
      const barcode = selectedPlateAddresses[0].usedByPlate?.barcode;
      if (barcode) {
        ImagerApi.clearDropLocation(barcode, false).then(() =>
          setPlateDropLocationCacheStatus(
            EDropLocationCacheStatus.NoDropLocationCacheExist
          )
        );
      }
    }
  };

  const onBackFromClearDropLocation = (clearDropOverride: boolean) => {
    if (clearDropOverride) {
      setPlateDropLocationCacheStatus(
        EDropLocationCacheStatus.NoDropLocationCacheExist
      );
    }
    setCommandPanel(SEARCH);
  };

  const onClearPlateRegistration = async () => {
    const plateAddress = selectedPlateAddresses[0];
    await StorageApi.clearPlateRegistration(
      plateAddress.moduleIdentifier,
      plateAddress.hotelNo,
      plateAddress.slotNo
    );
  };

  const isAllPlateOk = PlateUtil.isAllUsedByPlateOk(selectedPlateAddresses);

  const targetModule = [
    loadPort.identifier,
    ...chambers.map((c) => c.identifier),
    ...imagers.map((i) => i.identifier),
  ];

  const moveEnabled = targetModule.reduce(
    (canMove: boolean, currentValue: string) =>
    (canMove =
      canMove || (canMovePlateByModuleIdentifier[currentValue] ?? false)),
    false
  );

  const infoEnabled = selectedPlateAddresses.length === 1 && isAllPlateOk;
  const clearDropEnabled =
    selectedPlateAddresses.length === 1 &&
    isAllPlateOk &&
    plateDropLocationCacheStatus !==
    EDropLocationCacheStatus.NoDropLocationCacheExist;
  const imageNowEnabled = isAllPlateOk;
  const isClearPlateRegDisabled =
    !(
      selectedPlateAddresses.length === 1 &&
      selectedPlateAddresses[0].usedByPlate
    ) || !isRowSelected;

  const cancelMoveEnabled = selectedPlateAddresses.every(
    (plateAddress) =>
      plateAddress.usedByPlate != null &&
      plateAddress.usedByPlate.isQueuedForTransfer
  );

  const cancelMoveLabel = cancelMoveEnabled
    ? selectedPlateAddresses.every((plateAddress) =>
      loadPortModules.includes(plateAddress.moduleIdentifier)
    )
      ? "Cancel Store Plate(s)"
      : selectedPlateAddresses.every((plateAddress) =>
        storageModules.includes(plateAddress.moduleIdentifier)
      )
        ? "Cancel Eject Plate(s)"
        : "Cancel Move Plate(s)"
    : "";

  const columns: Column<PlateAddress>[] = React.useMemo(
    () => [
      {
        Header: "Project",
        id: "Project",
        accessor: (row) =>
          row.usedByPlate ? row.usedByPlate.projectName : "EMPTY",
      },
      {
        Header: "Experiment Name",
        id: "Experiment Name",
        accessor: (row) =>
          row.usedByPlate ? row.usedByPlate.experimentName : "EMPTY",
      },
      {
        Header: "Date dispensed",
        id: "Date dispensed",
        accessor: (row) =>
          row.usedByPlate
            ? DateUtil.toUsFormatString(new Date(row.usedByPlate.dateDispensed))
            : "EMPTY",
        width: 200,
      },
      {
        Header: "Plate Type",
        id: "Plate Type",
        accessor: (row) =>
          row.usedByPlate ? row.usedByPlate.plateType.plateTypeName : "EMPTY",
        width: 200,
      },
      {
        Header: "Plate Id",
        id: "Plate Id",
        accessor: (row) =>
          row.usedByPlate
            ? row.usedByPlate.plateNumber !== -1
              ? row.usedByPlate.plateId
              : "Unknown"
            : "EMPTY",
        width: 88,
      },
      {
        Header: "Barcode",
        id: "Barcode",
        accessor: (row) =>
          row.usedByPlate ? row.usedByPlate.barcode : "EMPTY",
        width: 80,
      },
      {
        Header: "Location",
        id: "Location",
        accessor: (row) =>
          PlateUtil.getPlateAddressLocation(moduleStateById, moduleById, row),
      },
      {
        Header: "Username",
        id: "Username",
        accessor: (row) =>
          row.usedByPlate ? row.usedByPlate.userName : "EMPTY",
      },
      {
        Header: "Status",
        id: "Status",
        accessor: (row) =>
          row.usedByPlate
            ? PlateUtil.getPlateAddressStatus(
              row.usedByPlate,
              plateBarcodesOnImager,
              plateBarcodesOnPsr
            )
            : "EMPTY",
        Filter: PlateAdressStatusColumnFilter,
        filter: "includes",
      },
    ],
    [moduleById, moduleStateById]
  );

  const plateAddressWithPlates = React.useMemo(() => {
    if (plateAddresses) {
      return plateAddresses
        .filter((pa) => pa.usedByPlate)
        .sort((a, b) =>
          a.usedByPlate?.plateId! > b.usedByPlate?.plateId! ? -1 : 1
        );
    } else {
      return [];
    }
  }, [plateAddresses]);

  const exportClick = () => {
    PlateApi.exportPlateAddress(filteredPlateAddress, "PlateAddressExport.csv");
  };

  useEffect(() => {
    if (selectedPlateAddresses.length === 1) {
      const plate = selectedPlateAddresses[0].usedByPlate;
      if (plate != null && plate.errorStatus === EPlateErrorStatus.OK) {
        setPlateDropLocationCacheStatus(
          EDropLocationCacheStatus.NoDropLocationCacheExist
        );
        ImagerApi.isDropLocationExist(plate.barcode).then((value) => {
          if (selectedPlateAddresses.length === 1) {
            setPlateDropLocationCacheStatus(value);
          }
        });
      }
    }
  }, [selectedPlateAddresses]);

  const getSelectedRowIds = () => {
    const result: number[] = [];
    selectedPlateAddresses.forEach((selected) => {
      const index = plateAddressWithPlates.findIndex((data) => {
        return selected.id === data.id;
      });
      if (index !== -1) result.push(index);
    });
    return result;
  };

  return (
    <>
      <ClearPlateConfirmationModal
        plateBarcode={selectedPlateAddresses?.[0]?.usedByPlate?.barcode ?? ""}
        isOpen={isModalClearPlateOpen}
        onCancel={() => setIsModalClearPlateOpen(false)}
        onOk={async () => {
          setIsModalClearPlateOpen(false);
          await onClearPlateRegistration();
        }}

      />
      <Modal
        show={showWaitingUpdatePlateInfo}
        hideOnBackdropClick={false}
        style={{
          width: 686,
          minHeight: 422,
        }}
      >
        <Modal.Body>
          <WarningWaitView
            title="Updating plate information"
            message={"Please wait,\n Updating plate information... "}
          />
        </Modal.Body>
      </Modal>

      <LayoutContent>
        <LayoutContent.Header>
          <Header
            style={{
              gridArea: "header",
            }}
          >
            <Breadcrumb
              items={[
                { title: "Search", to: "/plate/search", disabled: false },
              ]}
            />
            <Header.RightSide>
              <HeaderButton
                id={"CLEAR_FILTER"}
                label="Clear Filter"
                icon={<IconClearFilter />}
                onClick={() => clearFilter.action()}
                disabled={clearFilter.filters.length === 0}
              />
              <HeaderButton
                id={EXPORT}
                label="Export"
                icon={<IconExport />}
                onClick={exportClick}
              />
              <HeaderButton
                id={UPDATE_ALL_PLATE_INFO}
                label="Update All Plate Info"
                icon={<IconUpdateAllPlateInfo />}
                onClick={async () => {
                  setEnableUpdatePlateInfo(false);
                  setShowWaitingUpdatePlateInfo(true);
                  try {
                    await PlateApi.updatePlateInfo([]);
                  }
                  finally {
                    setEnableUpdatePlateInfo(true);
                    setShowWaitingUpdatePlateInfo(false);
                  }
                }}
                disabled={!enableUpdatePlateInfo}
              />
            </Header.RightSide>
          </Header>
        </LayoutContent.Header>
        <LayoutContent.Content>
          <CommonTable<PlateAddress>
            setClearFilter={setClearFilter}
            initialSelectedRowIndexes={getSelectedRowIds()}
            setSelectedRows={(rows) => {
              setSelectedPlateAddresses((prev) => {
                if (JSON.stringify(prev) === JSON.stringify(rows)) return prev;
                setCommandPanel(SEARCH);
                return rows;
              });
            }}
            setFilteredRow={setFilteredPlateAddress}
            data={plateAddressWithPlates}
            columns={columns}
            getRowStyle={(plateAddress, isSelected) =>
              PlateUtil.getPlateAddressRowStyle(
                moduleById,
                plateAddress,
                isSelected
              )
            }
            sortingRules={[
              {
                id: "Plate Id",
              },
            ]}
            style={{
              height: "100%",
            }}
            showTotalItem={{ show: true, totalText: "Total Plates: " }}
            showTotalSearchProperty={{
              show: true,
              searchText: "Search Results: ",
            }}
          />
        </LayoutContent.Content>
        <LayoutContent.SubMenu>
          <SidebarSubmenu>
            <NavSubItemWithPermission
              componentId={EComponentId.PlateLoadPort}
              label="Load Port"
              key="loadport"
              to="/plate/loadport"
              icon={<IconLoadport />}
            />
            <NavSubItemWithPermission
              componentId={EComponentId.PlateSearch}
              label="Search"
              key="search"
              to="/plate/search"
              icon={<IconSearch />}
            />
          </SidebarSubmenu>
        </LayoutContent.SubMenu>
        <LayoutContent.CommandPanel>
          <>
            {commandPanel === SEARCH && (
              <CommandPanel>
                <CommandPanel.PlateInfoHeader
                  plateAddresses={selectedPlateAddresses}
                />
                <CommandPanel.HorizontalContent>
                  <CommandButton
                    id={IMAGEPLATE}
                    icon={<IconImagePlate />}
                    content="Image Now"
                    disabled={!imageNowEnabled || !isRowSelected}
                    onClick={(id) => onClick(id)}
                    showArrow={true}
                  />
                  {!cancelMoveEnabled && (
                    <CommandButton
                      id={MOVE}
                      icon={<IconMovePlate />}
                      content="Move Plate To"
                      onClick={(id) => onClick(id)}
                      disabled={!moveEnabled || !isRowSelected}
                      showArrow={true}
                    />
                  )}
                  {cancelMoveEnabled && (
                    <CommandButton
                      id={CANCEL_MOVE}
                      icon={<IconMovePlate />}
                      content={cancelMoveLabel}
                      onClick={onCancelMove}
                      showArrow={false}
                      disabled={!isRowSelected}
                    />
                  )}

                  <CommandButton
                    id={INFO}
                    icon={<IconPlateInfo />}
                    content="Plate Information"
                    disabled={!infoEnabled || !isRowSelected}
                    onClick={(id) => onClick(id)}
                    showArrow={true}
                  />

                  <CommandButton
                    id={CLEARDROP}
                    icon={<IconClearDropLocation fill="#414042" />}
                    content="Clear All Drop Locations"
                    disabled={!clearDropEnabled || !isRowSelected}
                    onClick={(id) => onClearDropLocation()}
                    showArrow={
                      plateDropLocationCacheStatus ===
                      EDropLocationCacheStatus.DropLocationCacheExistOnImagerAndLims
                    }
                  />
                  <CommandButton
                    id={CLEAR_REGISTRATION}
                    icon={<IconClearPlateRegsitration />}
                    content="Clear Registration"
                    disabled={isClearPlateRegDisabled}
                    onClick={() => setIsModalClearPlateOpen(true)}
                  />
                  <CommandButton
                    id={UPDATE_PLATE_INFO}
                    icon={<IconUpdatePlateInfo />}
                    content="Update Plate Info"
                    disabled={!isRowSelected || !enableUpdatePlateInfo}
                    onClick={async () => {
                      const barcodes = selectedPlateAddresses.map(pa => pa.usedByPlate?.barcode ?? pa.reservedByPlate?.barcode ?? "").filter(bc => bc !== "");
                      setEnableUpdatePlateInfo(false);
                      try {
                        await PlateApi.updatePlateInfo(barcodes);
                      }
                      finally {
                        setEnableUpdatePlateInfo(true);
                      }
                    }}
                  />
                </CommandPanel.HorizontalContent>
              </CommandPanel>
            )}

            {commandPanel === IMAGEPLATE && (
              <ImagePlateUsing
                plateAddresses={selectedPlateAddresses}
                back={back}
                close={close}
                showImageDrop={false}
              />
            )}

            {commandPanel === INFO && (
              <PlateInformation
                plateAddress={selectedPlateAddresses[0]}
                backBtn={back}
              />
            )}
            {commandPanel === MOVE && (
              <MovePlate
                canMovePlateByModuleIdentifier={canMovePlateByModuleIdentifier}
                plateAddresses={selectedPlateAddresses}
                close={close}
                back={back}
              />
            )}
            {commandPanel === CLEARDROP && (
              <ClearDropLocation
                plateAddress={selectedPlateAddresses[0]}
                backBtn={onBackFromClearDropLocation}
              />
            )}
          </>
        </LayoutContent.CommandPanel>
      </LayoutContent>
    </>
  );
}
